/**
 * Modal dialogs used inside AnnotationTool: the student-identification gate
 * shown on first visit, and the note-editor for adding/editing margin notes.
 */
import React from 'react';
import { User } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

export function StudentLoginModal({
  studentId, setStudentId, studentName, setStudentName, onContinue,
}) {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <Dialog open onOpenChange={() => {}}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <User className="h-5 w-5" />
              Student Login
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-[#2D3748]">Student ID</label>
              <Input
                value={studentId}
                onChange={(e) => setStudentId(e.target.value)}
                placeholder="Enter your student ID"
                data-testid="student-id-input"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-[#2D3748]">Your Name</label>
              <Input
                value={studentName}
                onChange={(e) => setStudentName(e.target.value)}
                placeholder="Enter your name"
                data-testid="student-name-input"
              />
            </div>
          </div>
          <DialogFooter>
            <Button onClick={onContinue} className="btn-primary" data-testid="login-btn">
              Continue
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export function NoteEditorModal({
  open, onOpenChange, isEditing, content, setContent, onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{isEditing ? 'Edit Note' : 'Add Margin Note'}</DialogTitle>
        </DialogHeader>
        <Textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Enter your note..."
          rows={4}
          data-testid="note-content-input"
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} className="btn-primary" data-testid="save-note-btn">
            Save Note
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
